module.exports = __webpack_public_path__ + "components/flag/static/square/tn-e9c43f86b9451282e1c4bcd57947f780.svg";